import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useOffer } from "../../contexts/OfferContext";
export function CountdownDisplay() {
  const {
    minutes,
    seconds
  } = useOffer();
  return <div className="flex items-center justify-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Quedan ${minutes} minutos y ${seconds} segundos`} data-id="element-581" data-mp="1ai04jlhflx5e">
      <Unit value={minutes} label="Minutos" data-id="element-582" data-mp="229y3rmpykapp" />
      <span className="pb-6 font-display text-4xl font-bold text-gold-light" data-id="element-583" data-mp="228wfuhnuftqk">:</span>
      <Unit value={seconds} label="Segundos" data-id="element-584" data-mp="1y8449hri1cr4" />
    </div>;
}
function Unit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-585" data-mp="1tft8mr3skd4d">
      <div className="flex gap-1.5" data-id="element-586" data-mp="1oj2nvqh1ktcm">
        {value.split("").map((digit, i) => <div key={i} className="relative flex h-16 w-12 items-center justify-center overflow-hidden rounded-xl bg-cream text-cocoa-dark shadow-[0_8px_0_0_#8C6526] sm:h-20 sm:w-14" data-id="element-587" data-mp="2lxor4bqrwu5o" data-mpi={i}>
            <AnimatePresence mode="popLayout" initial={false} data-id="element-588" data-mp="1q40g385nrpph">
              <motion.span key={digit} initial={{
            y: "-100%",
            opacity: 0
          }} animate={{
            y: "0%",
            opacity: 1
          }} exit={{
            y: "100%",
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="font-display text-4xl font-bold tabular sm:text-5xl" data-id="element-589" data-mp="1q6mo18wgo788">
                {digit}
              </motion.span>
            </AnimatePresence>
            <span className="absolute inset-x-0 top-1/2 h-px bg-cocoa/10" aria-hidden data-id="element-590" data-mp="1cdonz992pqyc" />
          </div>)}
      </div>
      <span className="mt-3 text-[11px] font-semibold uppercase tracking-widest text-cream/60" data-id="element-591" data-mp="yf72li6n4qjl">{label}</span>
    </div>;
}